import { ScreenEnum } from '../hooks/navigation/Screens';
import lazyWithRetry from '../services/helpers/LazyWithRetry';

const AuthRoutes = [
  {
    path: ScreenEnum.Login,
    component: lazyWithRetry(() => import('../views/authentication/Login')),
  },
  {
    path: ScreenEnum.ForgotPassword,
    component: lazyWithRetry(() => import('../views/authentication/ForgotPassword')),
  },
  {
    path: ScreenEnum.ResetPassword,
    component: lazyWithRetry(() => import('../views/authentication/ResetPassword')),
  },
  {
    path: ScreenEnum.CreateNewPassword,
    component: lazyWithRetry(() => import('../views/authentication/CreateNewPassword')),
  },
];

export default AuthRoutes;
